var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCells1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #c9c9c9;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m22.47,13.1H7.53c-1.48,0-2.68,1.34-2.68,3v9.81c0,1.65,1.2,3,2.68,3h14.94c1.48,0,2.68-1.34,2.68-3v-9.81c0-1.65-1.2-3-2.68-3Zm1.05,3v9.81c0,.66-.47,1.2-1.05,1.2H7.53c-.58,0-1.05-.54-1.05-1.2v-9.81c0-.66.47-1.2,1.05-1.2h14.94c.58,0,1.05.54,1.05,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m8.42,8.75h5.15c.65,0,1.17-.53,1.17-1.17V2.42c0-.65-.53-1.17-1.17-1.17h-5.15c-.65,0-1.17.53-1.17,1.17v5.15c0,.65.53,1.17,1.17,1.17Zm.33-6h4.5v4.5h-4.5V2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m17.42,11.75h3.15c.65,0,1.17-.53,1.17-1.17v-3.15c0-.65-.53-1.17-1.17-1.17h-3.15c-.65,0-1.17.53-1.17,1.17v3.15c0,.65.53,1.17,1.17,1.17Zm.33-4h2.5v2.5h-2.5v-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m17.57,20.58c-.2-.15-.48-.11-.68.1-.4.4-.81.81-1.22,1.22v-4.35c0-.35-.22-.57-.58-.57h-.09s-.09,0-.13,0c-.16-.01-.32.04-.44.15-.12.11-.18.27-.18.46,0,1.13,0,2.25,0,3.38v.96l-1.21-1.21s-.05-.05-.08-.08c-.19-.16-.45-.17-.62-.04-.16.12-.29.26-.4.4-.16.21-.12.48.1.69l.92.92c.51.51,1.02,1.02,1.53,1.53.08.08.2.2.37.24h.2s.02,0,.02,0c.17-.04.28-.16.37-.24.58-.58,1.16-1.16,1.73-1.73l.69-.69s.05-.05.08-.08c.16-.19.18-.45.04-.63-.13-.16-.26-.3-.41-.41Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 30,
    height: 30
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCells1);
export default __webpack_public_path__ + "static/media/cells-1.30e3a92b1323461c9c91596ec990554e.svg";
export { ForwardRef as ReactComponent };